import { Card, Checkbox, DatePipe, Person } from '@abb-procure/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  InjectionToken,
  input,
} from '@angular/core';
import { MetadataUser } from '../../types/metadata-user.type';
import { SearchBaseDto } from '../../types/search-base-dto.type';
import { SearchResultItemDto } from '../../types/search-result-item-dto.type';
import { SearchEntityBadge } from '../search-entity-badge/search-entity-badge.component';

export const TOOLTIP_DATA = new InjectionToken<SearchResultItemDto>(
  'TOOLTIP_DATA',
);

@Component({
  selector: 'procure-search-result-detail',
  templateUrl: './search-result-detail.component.html',
  styleUrl: './search-result-detail.component.scss',
  imports: [Card, SearchEntityBadge, DatePipe, Checkbox, Person],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResultDetail {
  readonly item = input.required<SearchBaseDto | SearchResultItemDto>();

  protected readonly metadataItems = computed(() => {
    const item = this.item();

    if (!this.isResultItem(item)) {
      return [];
    }

    return Object.keys(item.metadata ?? {});
  });

  protected isResultItem(
    item: SearchBaseDto | SearchResultItemDto,
  ): item is SearchResultItemDto {
    return (item as SearchResultItemDto).metadata !== undefined;
  }

  protected isBoolean(value: unknown): value is boolean {
    return typeof value === 'boolean';
  }

  protected isMetadataUser(value: unknown): value is MetadataUser {
    return (value as MetadataUser).avatar_url !== undefined;
  }
}
